import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["vesselId", "dischargePortId", "eta", "confirmedLegs", "batchUpdateSelected"];

  initialize() {
    this.initialShipmentEta = this.element.dataset.shipmentEta;
    this.legId = this.element.dataset.legId;
    this.setConfirmedLegs([], true);
    this.lastShipmentsFetch = null;
    this.initialEta = this.etaTarget.value;
  }

  // array is an expected argument
  setConfirmedLegs(value, initial) {
    if (value.length) {
      this.confirmedLegsTarget.value = JSON.stringify(value);
      this.batchUpdateSelectedTarget.value = true;
    } else {
      this.confirmedLegsTarget.value = null;
      if (!initial) {
        this.batchUpdateSelectedTarget.value = false;
      }
    }
    this.confirmedLegs = value;
    this.setPreviewNote();
  }

  setPreviewNote() {
    let note = "";
    if (this.confirmedLegs.length) {
      const titles = this.confirmedLegs.map(
        (legId) =>
          (this.lastShipmentsFetch.find((shipment) => shipment.leg_id == legId) || {}).title
      );
      note = `Update action will also affect shipments ${titles.join(", ")}`;
    }

    this.element.querySelector(".preview-note").textContent = note;
  }

  connect() {
    $(".leg-vessel-eta-select2").on("select2:select", function () {
      let event = new Event("change", { bubbles: true }); // fire a native event
      this.dispatchEvent(event);
    });

    document.body.addEventListener(
      `cortana:legs-confirmed-${this.legId}`,
      this.confirmed.bind(this)
    );
    document.body.addEventListener(
      `cortana:legs-cancelled-${this.legId}`,
      this.cancelled.bind(this)
    );
  }

  updatedVessel() {
    this.setConfirmedLegs([]);
  }

  changed() {
    this.warnIfBigEtasDiff();
    this.getShipmentByVessel(
      this.vesselIdTarget.value,
      this.dischargePortIdTarget.value,
      this.initialEta,
      (data) => {
        this.lastShipmentsFetch = data;
        this.element.querySelector(".pause-eta-container").classList.remove("hidden");
        this.element.querySelector(".discharge_etd_update").classList.remove("hidden");
        this.showPopover();
      }
    );
  }

  confirmed(e) {
    this.setConfirmedLegs(e.detail.confirmedLegs);
    this.hidePopover();
  }

  cancelled() {
    this.setConfirmedLegs([]);
    this.hidePopover();
  }

  getShipmentByVessel(vesselId, dischargePortId, eta, callback) {
    const urlParams = `vessel_id=${vesselId}&discharge_port_id=${dischargePortId}&estimated_arrival=${eta}`;
    $.getJSON(`/admin/shipments/shipments_by_vessel?${urlParams}`, (data) => {
      data = data.filter((x) => x.leg_id != this.legId);
      callback(data);
    });
  }

  hidePopover() {
    $(this.etaTarget.parentElement).popover("hide");
  }

  preventPopoverEvent(e) {
    e.preventDefault();
  }

  warnIfBigEtasDiff() {
    const initialEta = new Date(this.initialShipmentEta);
    const newEta = new Date(this.etaTarget.value);
    const etasDiff = Math.abs((newEta - initialEta) / 86400000); // 24 * 60 * 60 * 1000
    const etaUpdateButton = this.etaTarget
      .closest('[data-toggle-target="secondary"]')
      .querySelector(".shipment-leg-update-button");

    if (etasDiff > 10 && etaUpdateButton.classList.contains("booking-confirmed")) {
      etaUpdateButton.setAttribute(
        "data-confirm",
        "This ETA seems very different from the existing one. Are you sure the date is correct?"
      );
    } else {
      etaUpdateButton.removeAttribute("data-confirm");
    }
  }

  showPopover() {
    if (!this.lastShipmentsFetch.length) {
      return;
    }

    $(this.etaTarget.parentElement).popover({
      title:
        "These other shipments are also on the same vessel, do you wish to adjust ETA for them?",
      content: () => this.popoverContent(this.lastShipmentsFetch),
      html: true,
      sanitize: false,
      trigger: "manual",
    });

    $(this.etaTarget.parentElement).popover("show");
  }

  popoverContent(allLegs) {
    const selectedValues = this.confirmedLegs.length
      ? this.confirmedLegs
      : allLegs.map((x) => x.leg_id);
    return `<div class="shipment-legs-popover" data-legs-popover-legs-value="${JSON.stringify(
      selectedValues
    )}" data-legs-popover-root-leg-id-value="${this.legId}" data-controller="legs-popover">
      <div class="popover-shipments">
        ${this.popoverShipmentLines(allLegs, selectedValues)}
      </div>
      <div class="popover-buttons">
        <button class="btn btn-primary btn-sm" data-action="legs-popover#confirm"> Include </button>
        <button class="btn btn-outline-secondary ml-1 btn-sm" data-leg-vessel-eta-target="cancel" data-action="legs-popover#cancel"> Cancel </button>
      </div>
    </div>`;
  }

  popoverShipmentLines(allLegs, selectedValues) {
    return allLegs
      .map(
        (leg) => `
      <div class="flex popover-shipment-item pt-1 pb-1 ${
        selectedValues.includes(leg.leg_id) ? "selected" : ""
      }" data-leg-id="${leg.leg_id}" data-action="click->legs-popover#change">
        <div>${leg.title} - ETA: ${
          leg.eta
            ? new Date(leg.eta).toLocaleDateString("en-NL", { day: "numeric", month: "short" })
            : "No ETA"
        } - ETD: ${
          leg.etd
            ? new Date(leg.etd).toLocaleDateString("en-NL", { day: "numeric", month: "short" })
            : "NO Discharge ETD"
        }</div>
        <div> <i class="icon check"></i> </div>
      </div>
      `
      )
      .join("");
  }
}
